import styled from 'styled-components'

export const RowList = styled.div`
  display: flex;
  flex-direction: column;
  border: var(--sl-border-base);
  border-radius: var(--sl-radius-2);
  overflow: hidden;
`

export const Row = styled.dl`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--sl-space-4);
  margin: 0;
  padding: var(--sl-space-3) var(--sl-space-4);
  background: var(--sl-bg-base);
  border-bottom: var(--sl-border-base);

  &:last-child {
    border-bottom: none;
  }

  dt {
    font: var(--sl-text-caption-1-font);
    color: var(--sl-fg-base-soft);
  }

  dd {
    margin: 0;
    font: var(--sl-text-emphasis-font);
    color: var(--sl-fg-base);
    text-align: right;
  }
`
